import { render, staticRenderFns } from "./StepItemHorizontal.vue?vue&type=template&id=549b63a0&scoped=true&"
import script from "./StepItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./StepItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./StepItemHorizontal.vue?vue&type=style&index=0&id=549b63a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b63a0",
  null
  
)

export default component.exports